import { render } from "./template.vue?vue&type=template&id=2b69c80f&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=2b69c80f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b69c80f"]])

export default __exports__